import { forwardRef } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const PlayBold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <path d="M4.75 3.47998L11.79 7.53998L18.83 11.61L11.79 15.68L4.75 19.74V3.47998Z" fill="white" style={{ fill: "var(--fillg)" }} />
            </svg>
        </div>
    );
});
